import { Mail } from 'lucide-react'
import { SOCIAL_MEDIA, CONTACT } from './constants'
import { ChromeLink } from './config'
import { LinkedInIcon, InstagramIcon, FacebookIcon } from './icons/social-icons'
import { NewsletterSignup } from './NewsletterSignup'

export function Footer() {
  return (
    <footer className="bg-card border-border border-t">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-12 text-sm md:grid-cols-3">
        {/* Left: Branding & Copyright */}
        <div className="text-muted-foreground space-y-2">
          <p className="text-foreground font-serif text-xl">Fugue Lab</p>
          <p>Websites & Digital Strategy for Classical Music</p>
          <p>© {new Date().getFullYear()} Fugue Lab. All rights reserved.</p>
          <p>Fugue Lab is operated by Garrett John Law, Sherman Oaks, CA.</p>
          <NewsletterSignup className="max-w-xs pt-4" />
        </div>

        {/* Center: Navigation */}
        <div className="text-muted-foreground flex flex-col space-y-2 md:items-center md:space-y-1">
          <p className="text-muted text-xs tracking-wider uppercase">Explore</p>
          <ChromeLink href="/" className="hover:text-foreground transition">
            Home
          </ChromeLink>
          <ChromeLink href="/pricing" className="hover:text-foreground transition">
            Pricing
          </ChromeLink>
          <ChromeLink href="/who-we-help" className="hover:text-foreground transition">
            Who We Help
          </ChromeLink>
          <ChromeLink href="/resources" className="hover:text-foreground transition">
            Resources
          </ChromeLink>
          <ChromeLink href="/portfolio" className="hover:text-foreground transition">
            Portfolio
          </ChromeLink>
          <ChromeLink href="/how-we-measure" className="hover:text-foreground transition">
            How We Measure
          </ChromeLink>
          <ChromeLink href="/about" className="hover:text-foreground transition">
            About
          </ChromeLink>
          <ChromeLink href="/contact" className="hover:text-foreground transition">
            Contact
          </ChromeLink>
          <p className="text-muted mt-4 text-xs tracking-wider uppercase">For Clients</p>
          <ChromeLink href="/requests" className="hover:text-foreground transition">
            Request an Update
          </ChromeLink>
        </div>

        {/* Right: Contact & Socials */}
        <div className="text-muted-foreground space-y-2 md:text-right">
          <p className="text-xs tracking-wider uppercase">Contact</p>
          <p>Based in Los Angeles, CA</p>
          <p>
            <a
              href={`mailto:${CONTACT.email}`}
              className="hover:text-foreground flex items-center justify-center gap-1 transition md:justify-end"
            >
              <Mail className="h-4 w-4" />
              {CONTACT.email}
            </a>
          </p>
          <div className="flex justify-center gap-4 pt-2 md:justify-end">
            <a
              href={SOCIAL_MEDIA.linkedin}
              className="hover:text-foreground transition"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <LinkedInIcon className="h-5 w-5" />
            </a>
            <a
              href={SOCIAL_MEDIA.instagram}
              className="hover:text-foreground transition"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <InstagramIcon className="h-5 w-5" />
            </a>
            <a
              href={SOCIAL_MEDIA.facebook}
              className="hover:text-foreground transition"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FacebookIcon className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      {/* Legal links + Made by Fugue */}
      <div className="text-muted-foreground space-y-2 pb-6 text-center text-xs">
        <div className="flex justify-center gap-4">
          <ChromeLink href="/privacy" className="hover:text-foreground transition">
            Privacy Policy
          </ChromeLink>
          <ChromeLink href="/accessibility" className="hover:text-foreground transition">
            Accessibility
          </ChromeLink>
        </div>
        <div>
          Designed and built by{' '}
          <a href="https://fuguelab.com" className="text-primary underline" target="_blank" rel="noopener noreferrer">
            Fugue Lab
          </a>
        </div>
      </div>
    </footer>
  )
}
